/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  FormControlLabel,
  Switch,
} from '@material-ui/core';

import {
  addCompany,
  selectIsPending,
} from '../../store/companySlice';

import {
  setMessage,
} from '../../store/authSlice';

import {
  isRequired,
  validEmail,
  validateField,
  validateForm,
} from '../../helpers/validation';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function AddCompanyForm({ callback }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isPending = useSelector(selectIsPending);
  const [formErrors, setFormErrors] = useState({});
  const [formValues, setFormValues] = useState({
    clientId: null,
    companyCode: '',
    companyType: '',
    companyName: '',
    companyEmail: '',
    companyPhone: '',
    companyLogo: '',
    autoAddressVerification: false,
    autoIdentityVerification: false,
  });

  const formRules = {
    clientId: [isRequired],
    companyType: [isRequired],
    companyCode: [isRequired],
    companyName: [isRequired],
    companyEmail: [isRequired, validEmail],
    companyPhone: [isRequired],
    companyLogo: [isRequired],
    autoAddressVerification: [],
    autoIdentityVerification: [],
  };

  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.checked || event.target.value });
  };

  const handleBlur = (event) => {
    validateField(formRules, formErrors, setFormErrors, event.target.name, event.target.value);
  };

  const attemptAddCompany = (event) => {
    event.preventDefault();
    if (validateForm(formRules, formValues, formErrors, setFormErrors)) {
      dispatch(addCompany(formValues))
        .unwrap()
        .then(() => {
          dispatch(setMessage({ message: 'Company created', severity: 'success' }));
          if (callback) callback();
        })
        .catch(() => {
          dispatch(setMessage({ message: 'Company could not be created', severity: 'error' }));
        });
    }
  };

  return (
    <form className={classes.form}>
      <TextField
        variant="outlined"
        margin="normal"
        id="company-clientid"
        label="Client ID"
        name="clientId"
        value={formValues.clientId}
        error={!!formErrors.clientId}
        helperText={formErrors.clientId}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isPending}
        fullWidth
        required
      />
      <TextField
        variant="outlined"
        margin="normal"
        id="company-type"
        label="Company Type"
        name="companyType"
        value={formValues.companyType}
        error={!!formErrors.companyType}
        helperText={formErrors.companyType}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isPending}
        fullWidth
        required
      />
      <TextField
        variant="outlined"
        margin="normal"
        id="company-name"
        label="Company Name"
        name="companyName"
        value={formValues.companyName}
        error={!!formErrors.companyName}
        helperText={formErrors.companyName}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isPending}
        fullWidth
        required
      />
      <TextField
        variant="outlined"
        margin="normal"
        id="company-code"
        label="Company Code"
        name="companyCode"
        value={formValues.companyCode}
        error={!!formErrors.companyCode}
        helperText={formErrors.companyCode}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isPending}
        fullWidth
        required
      />
      <TextField
        variant="outlined"
        margin="normal"
        id="company-email"
        label="Company Email"
        name="companyEmail"
        autoComplete="email"
        value={formValues.companyEmail}
        onChange={handleChange}
        onBlur={handleBlur}
        error={!!formErrors.companyEmail}
        helperText={formErrors.companyEmail}
        disabled={isPending}
        fullWidth
        required
      />
      <TextField
        variant="outlined"
        margin="normal"
        id="company-phone"
        label="Company Phone"
        name="companyPhone"
        autoComplete="tel"
        value={formValues.companyPhone}
        error={!!formErrors.companyPhone}
        helperText={formErrors.companyPhone}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isPending}
        fullWidth
        required
      />
      <TextField
        variant="outlined"
        margin="normal"
        id="company-logo"
        label="Company Logo"
        name="companyLogo"
        value={formValues.companyLogo}
        error={!!formErrors.companyLogo}
        helperText={formErrors.companyLogo}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isPending}
        fullWidth
        required
      />
      <FormControlLabel
        control={(
          <Switch
            checked={formValues.autoAddressVerification}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={isPending}
            name="autoAddressVerification"
            color="primary"
          />
        )}
        label="Auto Address Verification"
      />
      <FormControlLabel
        control={(
          <Switch
            checked={formValues.autoIdentityVerification}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={isPending}
            name="autoIdentityVerification"
            color="primary"
          />
        )}
        label="Auto Identity Verification"
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.submit}
        onClick={attemptAddCompany}
        disabled={isPending}
        fullWidth
      >
        Submit
      </Button>
    </form>
  );
}
